export interface CategoryCScoreRow {
  grade: string;
  score: number;
}

const CATEGORY_C_GRADE_ORDER = [
  'A++',
  'A+/A',
  'A+',
  'A',
  'B++',
  'B+',
  'B',
  'C',
  'D',
  'E',
  'C2',
  'C1',
  'B2',
  'B1',
  'A2',
  'N1',
  'N2',
  'N3',
  'Grade 6',
  'Grade 5',
  'Grade 4',
  'Grade 3',
];

const CATEGORY_C_FALLBACK_VALUES: Record<string, number> = {
  'A++': 8.5,
  'A+/A': 7,
  'B++': 5.5,
  'B+': 4,
};

export const buildCategoryCScoreRows = (
  gradeValues: Record<string, number> = {},
): CategoryCScoreRow[] => {
  const rows: CategoryCScoreRow[] = [
    { grade: 'A++', score: Number(gradeValues['A++'] ?? CATEGORY_C_FALLBACK_VALUES['A++'] ?? 0) },
    { grade: 'A+/A', score: Number(gradeValues['A+'] ?? gradeValues['A'] ?? CATEGORY_C_FALLBACK_VALUES['A+/A'] ?? 0) },
    { grade: 'B++', score: Number(gradeValues['B++'] ?? CATEGORY_C_FALLBACK_VALUES['B++'] ?? 0) },
    { grade: 'B+', score: Number(gradeValues['B+'] ?? CATEGORY_C_FALLBACK_VALUES['B+'] ?? 0) },
    { grade: 'B', score: Number(gradeValues['B'] ?? 0) },
    { grade: 'C', score: Number(gradeValues['C'] ?? 0) },
    { grade: 'D', score: Number(gradeValues['D'] ?? 0) },
    { grade: 'E', score: Number(gradeValues['E'] ?? 0) },
    { grade: 'C2', score: Number(gradeValues['C2'] ?? 0) },
    { grade: 'C1', score: Number(gradeValues['C1'] ?? 0) },
    { grade: 'B2', score: Number(gradeValues['B2'] ?? 0) },
    { grade: 'B1', score: Number(gradeValues['B1'] ?? 0) },
    { grade: 'A2', score: Number(gradeValues['A2'] ?? 0) },
    { grade: 'N1', score: Number(gradeValues['N1'] ?? 0) },
    { grade: 'N2', score: Number(gradeValues['N2'] ?? 0) },
    { grade: 'N3', score: Number(gradeValues['N3'] ?? 0) },
    { grade: 'Grade 6', score: Number(gradeValues['Grade 6'] ?? 0) },
    { grade: 'Grade 5', score: Number(gradeValues['Grade 5'] ?? 0) },
    { grade: 'Grade 4', score: Number(gradeValues['Grade 4'] ?? 0) },
    { grade: 'Grade 3', score: Number(gradeValues['Grade 3'] ?? 0) },
  ];

  return rows
    .filter(row => row.score > 0)
    .sort((a, b) => {
      const indexA = CATEGORY_C_GRADE_ORDER.indexOf(a.grade);
      const indexB = CATEGORY_C_GRADE_ORDER.indexOf(b.grade);
      const resolvedA = indexA === -1 ? CATEGORY_C_GRADE_ORDER.length : indexA;
      const resolvedB = indexB === -1 ? CATEGORY_C_GRADE_ORDER.length : indexB;
      if (resolvedA !== resolvedB) return resolvedA - resolvedB;
      return a.grade.localeCompare(b.grade);
    });
};
